module.exports = __webpack_public_path__ + "static/media/forward.85f46a72.svg";